/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ShopInputs */

const en_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shop`)
};

const es_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienda`)
};

const fr_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boutique`)
};

const de_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shop`)
};

const ja_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショップ`)
};

const zh_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商店`)
};

const ar_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسوق`)
};

const id_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belanja`)
};

const it_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negozio`)
};

const ru_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазин`)
};

const pt_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar`)
};

const ko_shop = /** @type {(inputs: ShopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어`)
};

/**
* | output |
* | --- |
* | "Shop" |
*
* @param {ShopInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shop = /** @type {((inputs?: ShopInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ShopInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shop(inputs)
	if (locale === "es") return es_shop(inputs)
	if (locale === "fr") return fr_shop(inputs)
	if (locale === "de") return de_shop(inputs)
	if (locale === "ja") return ja_shop(inputs)
	if (locale === "zh") return zh_shop(inputs)
	if (locale === "ar") return ar_shop(inputs)
	if (locale === "id") return id_shop(inputs)
	if (locale === "it") return it_shop(inputs)
	if (locale === "ru") return ru_shop(inputs)
	if (locale === "pt") return pt_shop(inputs)
	return ko_shop(inputs)
});